// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__pNj4L","overflowing":"ReadFullNote_overflowing__2w6-U"};